import Vue from "vue";
import { ActionTree } from "vuex";
import { IPagination, RootState } from "@/types";
import {
  IUser,
  IUserListRequest,
  IUserCreateRequest,
  // ICompanyCreateRequest,
  // IMemberCreateRequest,
  IUserUpdateRequest,
  UserState,
} from "@/types/user";
import axios from "axios";

const actions: ActionTree<UserState, RootState> = {
  async saleGetList({ commit }, params: IUserListRequest) {
    try {
      const response = await axios.get<IPagination<IUser[]>>("/sales/sale", {
        params,
      });

      commit("pagination", response.data);
      commit("error/resetError", null, { root: true });
    } catch (error) {
      if (error.response) {
        commit("error/error", error.response.data, { root: true });
      }
    }
  },
  async saleGet({ commit }, userId: number) {
    try {
      const response = await axios.get<IUser>(`sales/sale/${userId}`);

      commit("single", response.data);
      commit("error/resetError", null, { root: true });
    } catch (error) {
      if (error.response) {
        commit("error/error", error.response.data, { root: true });
      }
    }
  },
  async adminUpdate(
    { commit },
    data: { user_id: number; params: IUserUpdateRequest }
  ) {
    try {
      const response = await axios.patch<IUser>(
        `/sales/user/${data.user_id}`,
        data.params
      );

      commit("single", response.data);
      commit("error/resetError", null, { root: true });
      Vue.prototype.$flashStorage.flash("更新完了", "success", {
        timeout: 3000,
        important: true,
      });
      return true;
    } catch (error) {
      if (error.response) {
        commit("error/error", error.response.data, { root: true });
      }
      Vue.prototype.$flashStorage.flash(
        "更新失敗:入力した値を確認してください",
        "error",
        {
          timeout: 3000,
          important: true,
        }
      );
      return false;
    }
  },
  async adminCreate({ commit }, params: IUserCreateRequest) {
    try {
      const response = await axios.post<IUser>(`/sales/user`, params);

      commit("single", response.data);
      commit("error/resetError", null, { root: true });
      Vue.prototype.$flashStorage.flash("作成完了", "success", {
        timeout: 3000,
        important: true,
      });
      return true;
    } catch (error) {
      if (error.response) {
        commit("error/error", error.response.data, { root: true });
      }
      Vue.prototype.$flashStorage.flash(
        "作成失敗:入力した値を確認してください",
        "error",
        {
          timeout: 3000,
          important: true,
        }
      );
      return false;
    }
  },
  // async companyCreate({ commit }, params: ICompanyCreateRequest) {
  //   try {
  //     const response = await axios.post<IUser>(`/register`, params);

  //     commit("single", response.data);
  //     commit("error/resetError", null, { root: true });
  //     Vue.prototype.$flashStorage.flash("作成完了", "success", {
  //       timeout: 3000,
  //       important: true,
  //     });
  //     return true;
  //   } catch (error) {
  //     if (error.response) {
  //       commit("error/error", error.response.data, { root: true });
  //     }
  //     Vue.prototype.$flashStorage.flash(
  //       "作成失敗:入力した値を確認してください",
  //       "error",
  //       {
  //         timeout: 3000,
  //         important: true,
  //       }
  //     );
  //     return false;
  //   }
  // },
  // async memberCreate({ commit }, params: IMemberCreateRequest) {
  //   try {
  //     const response = await axios.post<IUser>(`/sales/member`, params);

  //     commit("single", response.data);
  //     commit("error/resetError", null, { root: true });
  //     Vue.prototype.$flashStorage.flash("作成完了", "success", {
  //       timeout: 3000,
  //       important: true,
  //     });
  //     return true;
  //   } catch (error) {
  //     if (error.response) {
  //       commit("error/error", error.response.data, { root: true });
  //     }
  //     Vue.prototype.$flashStorage.flash(
  //       "作成失敗:入力した値を確認してください",
  //       "error",
  //       {
  //         timeout: 3000,
  //         important: true,
  //       }
  //     );
  //     return false;
  //   }
  // },
  async adminDelete({ commit }, usear_id: number) {
    try {
      await axios.delete(`/sales/user/${usear_id}`);
      Vue.prototype.$flashStorage.flash("削除完了", "success", {
        timeout: 3000,
        important: true,
      });
      commit("error/resetError", null, { root: true });

      return true;
    } catch (error) {
      if (error.response) {
        commit("error/error", error.response.data, { root: true });
      }
      Vue.prototype.$flashStorage.flash("削除失敗", "error", {
        timeout: 3000,
        important: true,
      });

      return false;
    }
  },
  async isUniqueId(state, login_id: number) {
    try {
      const response = await axios.get<boolean>(
        `user/is-unique-id/${login_id}`
      );
      return response.data;
    } catch (error) {
      return false;
    }
  },
  async isUniqueEmail(state, email: string) {
    try {
      const response = await axios.get<boolean>(
        `user/is-unique-email/${email}`
      );
      return response.data;
    } catch (error) {
      return false;
    }
  },
};

export default actions;
